import React, { Fragment } from 'react';
import classNames from 'classnames';
import Heading from "@scentregroup/ui/components/heading";
import Paragraph from "@scentregroup/ui/components/paragraph";
import { Link } from '@scentregroup/shared/link';
import ExternalLink from '../external-link';
import UtilityBox from '../utility-box-v2';
import UtilityBoxItem from '../utility-box-item-v2';
import style from './index.module.scss';
import locationLink from '../../helpers/location-link';
import formatTelephoneNumber from '../../helpers/telephone-number';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PlanVisitUtilityBox = _ref => {
  let {
    heading,
    name,
    address,
    address2,
    phoneNumber,
    email,
    conciergeService,
    centreSlug,
    latitude,
    longitude,
    country
  } = _ref;
  return /*#__PURE__*/_jsxs(UtilityBox, {
    className: classNames(style.utilityBox, style.fullWidth),
    "data-id": "plan-visit-utility-box_index_PlanVisitUtilityBox_UtilityBox",
    children: [address && /*#__PURE__*/_jsxs(Fragment, {
      children: [/*#__PURE__*/_jsx(Heading, {
        type: "small",
        "data-id": "plan-visit-utility-box_index_PlanVisitUtilityBox_Fragment_Heading",
        children: "Address"
      }, "heading"), /*#__PURE__*/_jsxs(UtilityBoxItem, {
        icon: "location-drop-pin",
        role: "heading",
        "aria-label": "Store Location",
        "aria-level": "4",
        classNames: {
          childWrapper: style.childWrapper,
          icon: style.icon
        },
        "data-id": "plan-visit-utility-box_index_PlanVisitUtilityBox_Fragment_UtilityBoxItem",
        children: [name && /*#__PURE__*/_jsx(Heading, {
          type: "extrasmall",
          "data-id": "plan-visit-utility-box_index_PlanVisitUtilityBox_Heading",
          children: name
        }), /*#__PURE__*/_jsxs(Paragraph, {
          type: "medium",
          "data-id": "plan-visit-utility-box_index_PlanVisitUtilityBox_UtilityBoxItem_Paragraph",
          children: [address, address2 && /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx("br", {
              "data-id": "plan-visit-utility-box_index_PlanVisitUtilityBox_br"
            }), address2]
          })]
        }), latitude && longitude && /*#__PURE__*/_jsx(Paragraph, {
          type: "medium",
          "data-id": "plan-visit-utility-box_index_PlanVisitUtilityBox_Paragraph",
          children: /*#__PURE__*/_jsx(ExternalLink, {
            className: style.directionLink,
            url: locationLink(latitude, longitude),
            "data-id": "plan-visit-utility-box_index_PlanVisitUtilityBox_Paragraph_ExternalLink",
            children: "Get directions"
          })
        })]
      }, "item")]
    }), /*#__PURE__*/_jsx(Heading, {
      type: "small",
      "data-id": "plan-visit-utility-box_index_PlanVisitUtilityBox_UtilityBox_Heading",
      children: heading
    }), /*#__PURE__*/_jsx(UtilityBoxItem, {
      icon: "phone",
      role: "heading",
      "aria-level": "4",
      "aria-label": "Phone Number",
      classNames: {
        childWrapper: style.childWrapper,
        icon: style.icon
      },
      "data-id": "plan-visit-utility-box_index_PlanVisitUtilityBox_UtilityBox_UtilityBoxItem",
      children: /*#__PURE__*/_jsx(Paragraph, {
        type: "medium",
        "data-id": "plan-visit-utility-box_index_PlanVisitUtilityBox_UtilityBoxItem_Paragraph",
        children: /*#__PURE__*/_jsx("a", {
          href: "tel:".concat(formatTelephoneNumber(phoneNumber, country)),
          "data-id": "plan-visit-utility-box_index_PlanVisitUtilityBox_Paragraph_a",
          children: phoneNumber
        })
      })
    }), /*#__PURE__*/_jsx(UtilityBoxItem, {
      icon: "email",
      role: "heading",
      "aria-level": "4",
      "aria-label": "Email Address",
      classNames: {
        childWrapper: style.childWrapper,
        icon: style.icon,
        item: style.item
      },
      "data-id": "plan-visit-utility-box_index_PlanVisitUtilityBox_UtilityBox_UtilityBoxItem",
      children: /*#__PURE__*/_jsx(Paragraph, {
        type: "medium",
        "data-id": "plan-visit-utility-box_index_PlanVisitUtilityBox_UtilityBoxItem_Paragraph",
        children: /*#__PURE__*/_jsx(ExternalLink, {
          url: "mailto:".concat(email),
          "data-id": "plan-visit-utility-box_index_PlanVisitUtilityBox_Paragraph_ExternalLink",
          children: "Email us"
        })
      })
    }), conciergeService && conciergeService.store && /*#__PURE__*/_jsx(UtilityBoxItem, {
      icon: "hours",
      classNames: {
        childWrapper: style.childWrapper,
        icon: style.icon,
        item: style.item
      },
      "data-id": "plan-visit-utility-box_index_PlanVisitUtilityBox_UtilityBoxItem",
      children: /*#__PURE__*/_jsx(Paragraph, {
        type: "medium",
        "data-id": "plan-visit-utility-box_index_PlanVisitUtilityBox_UtilityBoxItem_Paragraph",
        children: /*#__PURE__*/_jsx(Link, {
          to: "/".concat(centreSlug, "/service/").concat(conciergeService.sys.id, "/").concat(conciergeService.slug),
          className: style.conciergeLink,
          "data-id": "plan-visit-utility-box_index_PlanVisitUtilityBox_Paragraph_Link",
          children: "View Concierge Hours"
        })
      })
    })]
  });
};
export default PlanVisitUtilityBox;